import { isDesktop } from 'react-device-detect';
import BonusGameController from '../../controllers/bonus/BonusGameController';
import MainGridController from '../../controllers/grid/MainGridController';
import { COMPONENTS } from '../../lib/constants';
import { BonusGameGridView } from './BonusGameGridView';
import { BonusGameItems } from './BonusItems';

export const BonusGameView = {
	name: COMPONENTS.BONUS_GAME,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: BonusGameController,
			name: 'BonusGameController',
			config: {
				item: 'bonus_game_wrapper',
				val: 'bonus_game_wrapper'
			}
		},
		{
			Controller: MainGridController,
			name: 'BonusGameViewGrid',
			config: BonusGameGridView
		}
	],
	components: [
		{
			name: 'fg_holder',
			type: 'Sprite',
			components: [
				isDesktop
					? {
							name: 'bonus_fg',
							type: 'AnimatedSprite',
							position: {
								x: 155,
								y: 200
							},
							animation: {
								pattern: 'BIG_Alienhologram$.png',
								start: 0,
								end: 91,
								speed: 0.5,
								precision: 2,
								loop: true,
								scale: {
									x: isDesktop ? 1 : 2,
									y: isDesktop ? 1 : 2
								}
							}
						}
					: {
							name: 'bonus_fg',
							type: 'Sprite',
							img: 'featured_img_static',
							position: {
								x: 155,
								y: 200
							}
						},
				isDesktop && {
					name: 'bonus_fg_wow',
					type: 'AnimatedSprite',
					position: {
						x: 155,
						y: 200
					},
					animation: {
						pattern: 'Bigalienaligned_$.png',
						start: 0,
						end: 50,
						speed: 0.5,
						precision: 5,
						loop: false,
						scale: {
							x: isDesktop ? 1 : 2,
							y: isDesktop ? 1 : 2
						}
					}
				}
			]
		},
		{
			name: 'btn_holder',
			type: 'Sprite',
			components: [
				{
					name: 'bonus_btn',
					type: 'PressButton',
					bg: 'stop_btn',
					fg: 'stop_btn_lowered',
					icon: 'stop_icon'
				}
			]
		},

		{
			name: 'win_bg_wrapper',
			type: 'Sprite',
			components: [
				{
					name: 'win_bg',
					type: 'Sprite',
					img: 'bonus_total_win_bg',
					position: { x: 0, y: 0 },
					scale: {
						x: isDesktop ? 1 : 2,
						y: isDesktop ? 1 : 2
					}
				},
				{
					name: 'win_bg_border',
					type: 'AnimatedSprite',
					position: { x: -10, y: -35 },
					animation: {
						pattern: 'modalframe2_000$.png',
						start: 0,
						end: 88,
						speed: 0.5,
						precision: 2,
						loop: true,
						scale: {
							x: isDesktop ? 1 : 2,
							y: isDesktop ? 1 : 2
						}
					}
				},
				{
					name: 'win_text',
					type: 'Text',
					text: 'BONUS_WIN_TEXT',
					position: { x: 180, y: 10 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'win_value',
					type: 'Text',
					text: 'BONUS_WIN_VALUE',
					position: { x: 175, y: 35 },

					anchor: { x: 0.5, y: 0 }
				}
			]
		},
		{
			name: 'BonusItems',
			type: 'VisualComponent',
			component: BonusGameItems
		}
	]
};
